module.exports = __webpack_public_path__ + "img/bigpackfast-active.9ec8943c.svg";